module.exports = "<div class=\"img-wrapper\">\r\n    <img [src]=\"imgUrl\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/img-header/img-header.component.html
// module id = 773
// module chunks = 1